export const FRIENDFEED_POST = new RegExp(`^http://friendfeed.com/[^/]+/([0-9a-f]{8})(?:/|$)`);
